import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class FooterConfigService {
	constructor(
		private coreConfigService: ConfigService<ObgConfigFeAdaptiveClientCore>,
		private commonConfigService: ConfigService<ObgConfigFeAdaptiveClientCommon>
	) {}

	getCompactLinkColor(): string {
		return this.coreConfigService.get((x) => x.coreUi.footer.compactLinkColor, "primary");
	}

	/**
	 * This config is under jurisdiction
	 */
	getPaymentsVisible(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isPaymentsVisible, true);
	}

	/**
	 * This config is under jurisdiction
	 */
	getResponsibleGamingVisible$(): Observable<boolean | undefined> {
		return this.coreConfigService.get$((x) => x.coreUi.footer.isResponsibleGamingVisible, false);
	}

	getLicenceKeys(): string[] {
		return this.coreConfigService.get((x) => x.coreUi.footer.licences, ["footer.licence.mga"]);
	}

	getGameProvidersVisible(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isGameProvidersVisible, false);
	}

	getHomePageV2Enabled(): boolean {
		return this.commonConfigService.get((config) => config.commonUi.home.homePageV2?.isEnabled, false);
	}

	isLicenceTabExpanded(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isLicenceTabExpanded, false);
	}

	isFooterLanguageSelectorVisible$(): Observable<boolean | undefined> {
		return this.coreConfigService.get$((x) => x.coreUi.footer.languageSelectorVisible, true);
	}

	getSponsorshipIconsLimit(): number {
		return this.coreConfigService.get((x) => x.coreUi.footer.sponsorshipIconsLimit, 10);
	}

	isFooterSponsorshipTitleEnabled(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isFooterSponsorshipTitleEnabled, true);
	}

	isFooterSponsorshipIconEnabled(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isFooterSponsorshipIconEnabled, false);
	}

	isFooterAwardIconsEnabled(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isFooterAwardIconsEnabled, false);
	}

	isResponsibleGamingInfoEnabled(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isResponsibleGamingInfoEnabled, false);
	}

	isRegulatoryIconsFullSize(): boolean {
		return this.coreConfigService.get((x) => x.coreUi.footer.isRegulatoryIconsFullSize, false);
	}
}
